module.exports = __webpack_public_path__ + "static/img/puji2.1f2d0fb1.jpg";